module.exports = __webpack_public_path__ + "static/img/mp2.e645bdb5.jpg";